import React from 'react'
import Logo from '../images/logo-square.svg'

export default function LoadingScreen({ fading = false }) {
  return (
    <div className={`fixed inset-0 z-50 flex items-center justify-center bg-[#1e1e1e] ${fading ? 'loading-fade-out' : ''}`}>
      <div className="flex flex-col items-center gap-5">
        <img
          src={Logo}
          alt="DriftOps"
          className="w-24 h-24 rounded-xl shadow-lg logo-loading-bg"
        />
      </div>
    </div>
  )
}
